import { Divider, Stack, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { ListContentEntry } from "src/components/cards/senec-tile/dataTypes";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export interface ListCardContentProps {
    data: ListContentEntry[];
    sx?: SxProps<Theme>;
}

export const ListCardContent = ({ data, sx }: ListCardContentProps) => {
    const theme: SenecFPPTheme = useTheme();

    return (
        <Stack spacing={2} divider={<Divider flexItem />} sx={{ ...sx }}>
            {data.map((entry: ListContentEntry, index) => (
                <Stack
                    key={"list-content-row-" + index}
                    data-testid={"list-content-row-" + index}
                    direction="column"
                    sx={{ width: "100%" }}
                >
                    <Stack direction="row" justifyContent="space-between" flexWrap="wrap" useFlexGap>
                        <Stack sx={{ fontWeight: 500 }}>
                            <Typography variant="body1" {...(entry.color && { color: entry.color + " !important" })}>
                                {entry.label}
                            </Typography>
                            <Typography
                                variant="s1Bold"
                                color={(entry.color ? entry.color : theme.palette.neutralGray70.main) + " !important"}
                            >
                                {entry.underline}
                            </Typography>
                        </Stack>
                        {entry.end && <Stack alignItems="center">{entry.end}</Stack>}
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
};
